/**
 * Vendors API calls.
 */

import client from './client';

export async function fetchVendors(params = {}) {
  const { data } = await client.get('/vendors/', { params });
  return data;
}

export async function fetchVendor(id) {
  const { data } = await client.get(`/vendors/${id}/`);
  return data.data || data;
}

export async function createVendor(payload) {
  const { data } = await client.post('/vendors/', payload);
  return data.data || data;
}

export async function updateVendor(id, payload) {
  const { data } = await client.patch(`/vendors/${id}/`, payload);
  return data.data || data;
}

export async function deleteVendor(id) {
  await client.delete(`/vendors/${id}/`);
}

export async function restoreVendor(id) {
  const { data } = await client.post(`/vendors/${id}/restore/`);
  return data.data || data;
}
